module.exports = "https://cdn.hellotech.com/client-assets/thermostats_tablet_d324af340a47cb0ef18e0e3f7c0ed5a1.webp";